module.exports = __webpack_public_path__ + "static/img/logo_white.9e2a67db.png";